/**************************************************************************
 * Created on Feb 24 2026
 *
 *  # Honeywell Code Usage Policy
 *
 * **Honeywell Source Code Usage Policy Classification:** Highly Confidential
 *
 ********************************************************************************/

import React, { createContext, useContext, useState, useCallback } from 'react';
import useInactivityTimer from '../../hooks/useInactivityTimer';
import { SESSION_INACTIVE_TIMER } from '../../constant/constant';

interface SessionContextType {
  showSessionAlert: boolean;
  handleReactivate: () => void;
  startTimer: () => void;
  stopTimer: () => void;
  initiateTimer: boolean;
}

const SessionContext = createContext<SessionContextType>({
  showSessionAlert: false,
  handleReactivate: () => { },
  startTimer: () => { },
  stopTimer: () => { },
  initiateTimer: false
});

export function SessionProvider({ children }: { children: React.ReactNode }) {
  const [initiateTimer, setInitiateTimer] = useState(false);
  const { showSessionAlert, handleReactivate } =
    useInactivityTimer(parseInt(SESSION_INACTIVE_TIMER), initiateTimer);
  
  const startTimer = useCallback(() => {
    setInitiateTimer(true);
  }, []);
  
  const stopTimer = useCallback(() => {
    setInitiateTimer(false);
  }, []);

  
  return (
    <SessionContext.Provider value={{
      showSessionAlert,
      handleReactivate,
      startTimer,
      stopTimer,
      initiateTimer
    }}>
      {children}
    </SessionContext.Provider>
  );
}

export function useSession() {
  return useContext(SessionContext);
}
